import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AssetsGenerateUrlService, AssetUIModel } from '@thehubz/client/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Observable } from 'rxjs';

@Component({
  selector: 'thehubz-asset-pdf',
  templateUrl: './asset-pdf.component.html',
  styleUrls: ['./asset-pdf.component.scss'],
  standalone: true,
  imports: [CommonModule, PdfViewerModule, MatIconModule],
})
export class AssetPdfComponent implements OnInit {
  @Input() asset!: AssetUIModel;
  @Input() toolbar = false;
  @Input() hideFullScreen = false;

  mainURL$!: Observable<string>;

  totalPdfPages = 0;
  isPdfLoaded = false;
  page = 1;
  zoom = 0.8;

  constructor(private assetsUrlService: AssetsGenerateUrlService) {}

  ngOnInit(): void {
    this.mainURL$ = this.assetsUrlService.getMainPresignedUrl$(this.asset);
  }

  // pdf related
  afterPdfLoadComplete(pdfData: any) {
    this.totalPdfPages = pdfData.numPages;
    this.isPdfLoaded = true;
  }

  // pdf related
  nextPage() {
    this.page += 1;
  }

  // pdf related
  previousPage() {
    this.page -= 1;
  }

  // pdf related
  zoom_in() {
    this.zoom = this.zoom + 0.25;
  }

  // pdf related
  zoom_out() {
    if (this.zoom > 1) {
      this.zoom = this.zoom - 0.25;
    }
  }
}
